
const convertTableData = (data, numberWithCommas, numberNoDecimals) => {
  const headers = Object.keys(data[0]);

  // Per-column: detect whole-number columns and year columns (1900–2200, no thousands separator)
  const isWholeColumn = {};
  const isYearColumn = {};
  headers.forEach(col => {
    const nums = data.map(r => r[col]).filter(v => typeof v === 'number');
    if (nums.length === 0) return;
    isWholeColumn[col] = nums.every(v => v % 1 === 0);
    isYearColumn[col] = isWholeColumn[col] && nums.every(v => v >= 1900 && v <= 2200);
  });

  const content = data.map((row) => {
    const newRow = headers.map(column => {
      const val = row[column];
      if (val == null) return '';
      if (typeof val === 'number') {
        if (isYearColumn[column]) return String(Math.round(val));
        return isWholeColumn[column] ? numberNoDecimals(val) : numberWithCommas(val);
      }
      if (typeof val === 'object') return JSON.stringify(val);
      return val;
    });
    let newJson = {};
    headers.forEach((header, index) => {
      if(!header.endsWith("ID")) {
        newJson[header] = newRow[index];
      }
    })

    return newJson;
  })
  return content;
}
const isFloat = (value) => {
  const number = parseFloat(value);
  return !isNaN(number) && isFinite(value) && value.toString().includes('.');
}
export {
  convertTableData,
  isFloat
}
